app.controller("UserInfoController", ["$scope", "AuthService",
    function ($scope, AuthService ) {
        $scope.user = {};

        AuthService.getUserData().then(function (user) {
            $scope.user = user;
            console.log('00000000002222222000000000', user)
        });
    }
]);